export class ResourceMappingModel {
    id: string;
    name: string;
    category: string;
    modelnumber: string;
    producttype: string;
    productclass: string;
    productfamily: string;
    productId: string;
    productline: string;
    publishon: string;
    unpublishon: string;
    constructor(data?) {
      const resourceData = data || {};
      this.id = resourceData.id; 
      this.name = resourceData.name; 
      this.category = resourceData.category;
      this.modelnumber = resourceData.modelNumber;
      this.producttype = resourceData.productType;
      this.productclass = resourceData.productClass;
      this.productfamily = resourceData.productFamily;
      this.productline = resourceData.productLine;
      this.productId = resourceData.productId;
      this.publishon = resourceData.publishOn;
      this.unpublishon = resourceData.unpublishOn;
    }
  }


// WEBPACK FOOTER //
// ./src/app/resource-mapping/models/resource-mapping.model.ts